import { CustomField } from "./custom-field.model";

export class ContactList {
  id: number;
  name: string;
  ownerName: string;
  ownerEmail: string;
  replyToEmail: string;
  bounceEmail: string;
  notifyOwner: boolean;
  insAt: string;
  customFields: CustomField[] = [];
}
